import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { TimesheetsPage } from '@/features/timesheets';
import { TimesheetsSearchSchema } from '@/features/timesheets/search';

/** The Time app: the weekly grid and timer, approvals, the capacity board and leave. */
export const Route = createFileRoute('/_auth/o/$orgId/timesheets')({
  validateSearch: (search) => TimesheetsSearchSchema.parse(search),
  component: TimesheetsRoute,
});

function TimesheetsRoute() {
  const { orgId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <TimesheetsPage
      orgId={orgId}
      search={search}
      onSearchChange={(patch) => {
        void navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true });
      }}
    />
  );
}
